import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-solid-svg-icons';

import SearchResults from './search_results';
import { search } from './api';
import { debounce } from 'lodash';

const defaultState = {
  items: [],
  query: '',
  showResults: false
};

class SearchInput extends React.Component {
  static propTypes = {
    debounceDelay: PropTypes.number,
    disabled: PropTypes.bool,
    excludedItems: PropTypes.array.isRequired,
    itemLabel: PropTypes.string,
    queryKey: PropTypes.string.isRequired,
    renderItem: PropTypes.func.isRequired,
    searchParams: PropTypes.object,
    searchPath: PropTypes.string.isRequired,
    searchPlaceholder: PropTypes.string,
    show: PropTypes.bool,

    onSelect: PropTypes.func.isRequired
  }

  static defaultProps = {
    debounceDelay: 500,
    disabled: false
  }

  state = defaultState

  componentDidUpdate(previousProps) {
    if (this.props.show && !previousProps.show) {
      this.setState(defaultState);
    }

    if (this.props.disabled && !previousProps.disabled) {
      this.setState({ showResults: false });
    }
  }

  search = () => {
    const query = { [this.props.queryKey]: this.state.query };
    search(this.props.searchPath, query, this.props.searchParams).then((items) => {
      this.setState(({ query }) => ({
        activeQuery: query,
        items
      }));
    });
  }

  debouncedSearch = debounce(() => this.search(), this.props.debounceDelay)

  handleBlur = () => {
    this.setState({ showResults: false });
  }

  handleFocus = () => {
    if (this.state.query !== this.state.activeQuery) {
      this.search();
    }

    this.setState({ showResults: true });
  }

  handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      this.setState({ query: '', showResults: false });
    }
  }

  handleQueryChange = (event) => {
    this.setState({ showResults: true, query: event.target.value });
    this.debouncedSearch();
  }

  handleSelect = (item) => {
    this.setState({ showResults: false });
    this.props.onSelect(item);
  }

  render() {
    return (
      <div className="search-controls">
        {this.renderInput()}
        {this.renderResults()}
      </div>
    );
  }

  renderInput() {
    const { disabled, itemLabel, searchPlaceholder } = this.props;

    return (
      <React.Fragment>
        <label>Search {itemLabel}</label>

        <input
          className="form-control"
          disabled={disabled}
          placeholder={searchPlaceholder}
          value={this.state.query}
          onBlur={this.handleBlur}
          onChange={this.handleQueryChange}
          onFocus={this.handleFocus}
          onKeyDown={this.handleKeyDown}
        />

        <FontAwesomeIcon className="icon text-primary" icon={faSearch} />
      </React.Fragment>
    );
  }

  renderResults() {
    if (!this.state.showResults) {
      return null;
    }

    return (
      <SearchResults
        excludedItems={this.props.excludedItems}
        items={this.state.items}
        query={this.state.query}
        renderItem={this.props.renderItem}
        searching={this.state.activeQuery !== this.state.query}
        onSelect={this.handleSelect}
      />
    );
  }
}

export default SearchInput;
